import { render } from "./SpiritOfJapan5.vue?vue&type=template&id=d57ef532&scoped=true"
import script from "./SpiritOfJapan5.vue?vue&type=script&lang=js"
export * from "./SpiritOfJapan5.vue?vue&type=script&lang=js"

import "./SpiritOfJapan5.scss?vue&type=style&index=0&id=d57ef532&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d57ef532"]])

export default __exports__